import { useEffect, useMemo, useRef, useState } from "react";
import styles from "../../AboutYourCompany/AboutYourCompany.module.css";
import {ReactComponent as DropdownArrow} from '../../../../assets/icons/DropdownArrow.svg'

export function CustomSelect({
  label,
  required = false,
  placeholder = "Select",
  value,
  options = [],
  open,
  setOpen,
  onChange,
  containerRef,
  showSearch = true,
  onSearch,
}) {
  const [search, setSearch] = useState("");
  const localRef = useRef(null);
  const ref = containerRef || localRef;

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        setSearch("");
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open, ref, setOpen]);

  const selectedLabel = useMemo(() => {
    const found = options.find((item) => item.value === value);
    return found?.label || "";
  }, [options, value]);

  const filteredOptions = useMemo(() => {
    if (onSearch) return options;
    if (!search.trim()) return options;
    return options.filter((item) =>
      (item.label || "").toLowerCase().includes(search.toLowerCase())
    );
  }, [search, options, onSearch]);

  return (
    <div className={styles.field} ref={ref} style={{ position: "relative" }}>
      {label && (
        <label className={styles.label}>
          {label} {required && <span className={styles.required}>*</span>}
        </label>
      )}


      {open && showSearch ? (
        <div className={`${styles.csBtn} ${styles.csBtnOpen}`} style={{ display: "flex", alignItems: "center", padding: "0 12px" }}>
          <input
            type="text"
            value={search}
            autoFocus
            placeholder={selectedLabel || placeholder}
            onChange={(e) => { setSearch(e.target.value); if (onSearch) onSearch(e.target.value); }}
            style={{ flex: 1, border: "none", outline: "none", background: "transparent", fontSize: "inherit", color: "#101828", fontFamily: "inherit" }}
          />
          <span style={{ transition: 'transform 0.2s', transform: 'rotate(180deg)', display: 'inline-flex', alignItems: 'center', color: '#667085' }}><DropdownArrow/></span>
        </div>
      ) : (
        <button
          type="button"
          className={`${styles.csBtn} ${open ? styles.csBtnOpen : ""}`}
          onClick={() => setOpen((prev) => !prev)}
        >
          <span style={{ color: selectedLabel ? "#101828" : "#667085" }}>{selectedLabel || placeholder}</span>
          <span style={{ transition: 'transform 0.2s', transform: open ? 'rotate(180deg)' : 'rotate(0deg)', display: 'inline-flex', alignItems: 'center', color: '#667085' }}><DropdownArrow/></span>
        </button>
      )}

      {open && (
        <div className={styles.csDropdown} style={{ zIndex: 1000, position: "absolute", width: "100%" }}>
          {filteredOptions.length > 0 ? (
            filteredOptions.map((item) => {
              const isSelected = item.value === value;
              return (
                <div
                  key={item.value}
                  className={`${styles.csOption} ${isSelected ? styles.csOptionActive : ""}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    onChange(item.value);
                    setOpen(false);
                    setSearch("");
                  }}
                >
                  {item.label}
                </div>
              );
            })
          ) : (
            <div
              className={styles.csOption}
              style={{ cursor: "default", opacity: 0.6 }}
            >
              No results found
            </div>
          )}
        </div>
      )}
    </div>
  );
}